// JIM-1007-03 (Jim 2026-10-07): the primary badge names the slot the person
// fills — the consultant of record is not an "On-site Contact".
export function primaryBadge(role: string | null | undefined): string {
  if (role === 'consultant') return 'Consultant';
  if (role === 'contractor') return 'Contractor';
  if (role === 'inspector') return 'Inspector';
  return 'On-site Contact';
}
